export default __webpack_public_path__ + "static/media/01.006388f6.svg";